<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : inStockBills.pkid > 0 ? '编辑' : '新建'"
      width="1000px"
      class="inStockBillsEdit"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="inStockBills"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="inStockBills.pkid > 0" :span="12">
          <el-form-item label="领料单号" prop="billNo">
            <el-input v-model="inStockBills.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="退料仓" prop="locationName">
            <el-input v-model="inStockBills.locationName" :disabled="inStockBills.pkid > 0" readonly placeholder="请选择仓位">
              <el-button slot="append" icon="el-icon-search" :disabled="inStockBills.pkid > 0" @click="$refs.locationSelect.open()"/>
            </el-input>
            <warehouse-location-select ref="locationSelect" @select="locationSelect"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联单据编号" prop="relBillNo">
            <el-input v-model="inStockBills.relBillNo" :disabled="inStockBills.pkid > 0" readonly placeholder="请选择关联单据编号">
              <el-button slot="append" icon="el-icon-search" :disabled="inStockBills.pkid > 0" @click="$refs.productionOrderSelect.open()"/>
            </el-input>
            <production-order-select ref="productionOrderSelect" @select="productionOrderSelect"/>
          </el-form-item>
        </el-col>
        <el-col v-if="inStockBills.status === 2" :span="12">
          <el-form-item label="领料时间" prop="requireDate">
            <el-input v-model="inStockBills.requireDate" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="inStockBills.pkid > 0" :span="12">
          <el-form-item label="状态" prop="statusName">
            <el-input v-model="inStockBills.statusName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="inStockBills.pkid > 0" :span="12">
          <el-form-item label="制单时间" prop="createTime">
            <el-input v-model="inStockBills.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="inStockBills.pkid > 0" :span="12">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="inStockBills.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="note">
            <el-input v-model="inStockBills.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle" style="margin-top: 10px">退料明细</div>
      <el-table class="tableBox" :data="inStockBills.details" border>
        <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
        <el-table-column prop="materialName" align="left" label="物料名称" min-width="380"/>
        <el-table-column prop="RefRowIndex" align="center" label="收料仓" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.locationName" readonly placeholder="请选择收料仓">
              <el-button slot="append" icon="el-icon-search" @click="$refs.FLlocationSelect.open();setIndex(scope.$index)"/>
            </el-input>
            <warehouse-location-select ref="FLlocationSelect" @select="FLlocationSelect"/>
          </template>
        </el-table-column>
        <el-table-column prop="unitName" align="center" label="单位" width="60"/>
        <!-- <el-table-column prop="price" align="center" label="单价" width="60"/> -->
        <el-table-column align="center" label="数量" width="100" prop="quantity"/>
        <el-table-column align="center" label="实退数量" width="100" prop="actualQuantity"/>
        <el-table-column
            prop="note"
            align="center"
            label="备注"
            width="120"
            show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" placeholder="请输入"/>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import ProductionOrderSelect from "@/views/ProductionManagement/ProductionOrder/ProductionOrderSelect";
  import WarehouseLocationSelect from "@/views/information/WarehouseLocation/WarehouseLocationSelect";
  export default {
    name: "OutStockOrderEdit",
    components: { ProductionOrderSelect,WarehouseLocationSelect },
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        index:0,
        inStockBills: {
          outStockType: 2,
          pkid: 0,
          billNo: "",
          relBillNo: "",
          relBillId:"",
          requireDate: "",
          status: "",
          statusName:"",
          creatorName: "",
          createTime: "",
          note: "",
          locationName:"",
          locationNo:"",
          locationId:"",
          details: [],
        },
        ruleValidate: {
          locationName: { required: true, message: "请选择领料仓位", trigger: "change" },
          FLlocationName: { required: true, message: "请选择收料仓位", trigger: "change" },
          quantity: { required: true, trigger: "blur" },
          relBillNo:{required: true,message:"请选择关联单号", trigger: "change"},
        },
      };
    },
    methods: {
      open(row, disabled) {
        this.dialogVisible = true;
        if (row) {
          this.inStockBills.pkid = row.pkid;
          this.getData();
        }
        if (disabled) {
          this.disabled = true;
        }
      },

      // 根据出货订单id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `inStockBillBacks/${this.inStockBills.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.inStockBills = Object.assign(this.inStockBills, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      setIndex(index) {
        this.index = index;
      },

      //仓位选择
      locationSelect(row) {
        console.log(row);
        this.inStockBills.locationName = row.warehouseLocationName;
        this.inStockBills.locationNo = row.warehouseLocationNo;
        this.inStockBills.locationId = row.pkId;
      },

      FLlocationSelect(row) {
        this.inStockBills.details[this.index].locationName = row.warehouseLocationName;
        this.inStockBills.details[this.index].locationId = row.pkId;
      },

      //选择关联单号
      productionOrderSelect(row) {
        console.log(row);
        this.inStockBills.relBillNo = row.billNo;
        this.inStockBills.relBillId = row.pkid;
        this.inStockBills.locationId = row.locationId;
        this.inStockBills.locationName = row.warehouseLocationName;
        this.getOrderDetail(row.pkid);
      },

      //根据单号获取明细
      getOrderDetail(id) {
        this.$http.get("basic",`inStockBillBacks/getBackStock/${id}`).then((res)=>{
          console.log(res);
          this.inStockBills.details = res.data.details;
        });
      },

      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.inStockBills.details.length) {
              this.$confirm("请添加退料明细", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            let flag = false;
            this.inStockBills.details.forEach(item =>{ 
              if(!item.locationName) {
                flag = true;
              }
            });
            if(flag) {
              this.$confirm("请选择收料仓", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            console.log("1111111");
            this.submitLoading = true;
            this.$http
              .save("basic", "inStockBillBacks", this.inStockBills)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.inStockBills.pkid > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.inStockBillsEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.inStockBillsEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.inStockBillsEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.inStockBillsEdit .el-divider--horizontal {
  margin: 10px 0;
}

.inStockBillsEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
